import React from "react";
import NavigationBarContainer from "./NavigationBarContainer";
import InnsynPersonopplysningerFilterContainer from "./InnsynPersonopplysningerFilterContainer";
import InnsynPersonopplysningerResult from "./InnsynPersonopplysningerResult";

function InnsynPersonopplysningerPage() {
  return (
    <>
      <NavigationBarContainer page="personopplysninger" />
      <InnsynPersonopplysningerFilterContainer />
      <InnsynPersonopplysningerResult />
    </>
  );
}

export default InnsynPersonopplysningerPage;
